"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.optionalDecimalToMoney = exports.optionalDecimalToNumber = exports.decimalToMoney = exports.decimalToNumber = void 0;
/**
 * For prisma.Decimal
 *
 * @param decimal
 * @returns
 */
function decimalToNumber(decimal) {
    const d = decimal;
    return d.toNumber ? d.toNumber() : decimal;
}
exports.decimalToNumber = decimalToNumber;
/**
 * For prisma.Decimal to Money
 *
 * @param decimal
 * @returns
 */
function decimalToMoney(decimal) {
    return decimalToNumber(decimal);
}
exports.decimalToMoney = decimalToMoney;
function optionalDecimalToNumber(decimal) {
    return decimal != null ? decimalToNumber(decimal) : undefined;
}
exports.optionalDecimalToNumber = optionalDecimalToNumber;
function optionalDecimalToMoney(decimal) {
    return decimal != null ? decimalToMoney(decimal) : undefined;
}
exports.optionalDecimalToMoney = optionalDecimalToMoney;
